import MajorTestResultLayout from './components/MajorTestResultLayout';
import { renderMajorTestContent } from './content';
import useMajorTestResultPage from './hooks/useMajorTestResultPage';
import { MajorTestKind } from './types';

type MajorTestResultPageProps = {
  testKind: MajorTestKind;
};

const MajorTestResultPage = ({ testKind }: MajorTestResultPageProps) => {
  const {
    loading,
    myResult,
    resultId,
    historyItems,
    openContactForm,
    toggleContactForm,
    handleDownloadPdf,
    preparingPdf,
    refreshResult,
    pdfElement,
    config,
    resultUserId,
    backPath,
  } = useMajorTestResultPage(testKind);

  return (
    <MajorTestResultLayout
      config={config}
      loading={loading}
      resultId={resultId}
      backPath={backPath}
      historyItems={historyItems}
      onDownloadPdf={handleDownloadPdf}
      preparingPdf={preparingPdf}
      onContactClick={toggleContactForm}
      openContactForm={openContactForm}
      onContactFormClose={toggleContactForm}
      pdfElement={pdfElement}
      resultUserId={resultUserId}>
      {!loading &&
        myResult &&
        renderMajorTestContent({
          kind: testKind,
          myResult,
          resultId,
          onContactClick: toggleContactForm,
          onResultUpdated: refreshResult,
        })}
    </MajorTestResultLayout>
  );
};

export default MajorTestResultPage;

export const MeaningMajorResult = () => <MajorTestResultPage testKind="meaning" />;
export const NeedsMajorResult = () => <MajorTestResultPage testKind="needs" />;
export const NeedsProMajorResult = () => <MajorTestResultPage testKind="needsPro" />;
export const PreferenceMajorResult = () => <MajorTestResultPage testKind="preference" />;
export const PreferenceJeuneMajorResult = () => <MajorTestResultPage testKind="preferenceJeune" />;
export const HarmonyMajorResult = () => <MajorTestResultPage testKind="harmony" />;
export const StudyMajorResult = () => <MajorTestResultPage testKind="study" />;
